import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SMChecklist from "@/pages/SMChecklist";
import { useAuth } from "@/context/AuthContext";

export default function MySMChecklist() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role !== "senior_management") {
      navigate("/my-portal/dashboard", { replace: true });
    }
  }, [user, navigate]);

  if (!user || user.role !== "senior_management") return null;
  return <SMChecklist forSelf />;
}
